import type { State } from './CompareContext';

export type AddAction = {
  readonly type: 'add';
  readonly carline: string;
};

export type RemoveAction = {
  readonly type: 'remove';
  readonly carline: string;
};

export type ClearAction = {
  readonly type: 'clear';
};

export type InitAction = {
  readonly type: 'init';
  readonly carlines: string[];
  readonly ngcCarlines: string[];
};

export type SetCarsAction = {
  readonly type: 'set-cars';
  readonly amount: 2 | 3;
};

export type Action = AddAction | RemoveAction | ClearAction | InitAction | SetCarsAction;

const add = (state: State, { carline }: AddAction): State => {
  if (state.carlines.length >= state.amount || state.carlines.indexOf(carline) !== -1) {
    return state;
  }

  return {
    ...state,
    carlines: [...state.carlines, carline],
  };
};

const remove = (state: State, { carline }: RemoveAction): State => {
  const index = state.carlines.indexOf(carline);
  if (index === -1) {
    return state;
  }

  return {
    ...state,
    carlines: state.carlines.filter((id) => id !== carline),
  };
};

const clear = (state: State): State => {
  if (state.carlines.every((carline) => carline === undefined)) {
    return state;
  }
  return { ...state, carlines: [] };
};

const init = (state: State, action: InitAction): State => {
  return {
    ...state,
    carlines: action.carlines
      .slice(0, state.amount)
      .filter((id) => action.ngcCarlines.indexOf(id) !== -1),
  };
};

const setCars = (state: State, { amount }: SetCarsAction): State => {
  if (state.amount !== amount) {
    return { ...state, amount, carlines: state.carlines.slice(0, amount) };
  }
  return state;
};

export const getNumberOfCars = (mobile: boolean): 2 | 3 => (mobile ? 2 : 3);

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'add':
      return add(state, action);
    case 'remove':
      return remove(state, action);
    case 'clear':
      return clear(state);
    case 'init':
      return init(state, action);
    case 'set-cars':
      return setCars(state, action);
    default:
      return state;
  }
};
